import { CAPITAL_ONE_EXCLUSIVE_EVENT_TAG } from '../constants.js'

const sliceBucketedSuggestions = bucketedSuggestions => {
    if (!(bucketedSuggestions && typeof bucketedSuggestions === 'object' && !Array.isArray(bucketedSuggestions))) { throw new Error('Invalid Argument: `bucketedSuggestions` Object is required.') }

    const events = (bucketedSuggestions.events || []).slice(0, 5).map(event => formatEvent(event))
    const performers = (bucketedSuggestions.performers || []).slice(0, 3)
    const venues = (bucketedSuggestions.venues || []).slice(0, 2)

    const nonCitySuggestionsCount = events.length + performers.length + venues.length

    const cities = (bucketedSuggestions.cities || []).slice(0, Math.max(10 - nonCitySuggestionsCount, 1))

    return {
        cities,
        events,
        performers,
        venues
    }
}

const formatEvent = event => {
    return {
        ...event,
        isExclusive: (event.segment || '').toLowerCase() === CAPITAL_ONE_EXCLUSIVE_EVENT_TAG
    }
}

export {
    sliceBucketedSuggestions
}
